import { mutateApi } from "src/utils/api/ApiMethods"

export const requestFuelPrices = async ({ data }) => {
  return mutateApi({
    url: `/fuel_price_requests`,
    method: "POST",
    data,
  })
}
